module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmIiBoZWlnaHQ9IjFlbSIgd2lkdGg9IjFlbSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+PHBhdGggZD0iTTUwNC41IDc1LjVjLTEwLTEwLTI2LjItMTAtMzYuMiAwTDE2MS42IDM4Mi4yIDQzLjcgMjY0LjNjLTEwLTEwLTI2LjItMTAtMzYuMiAwLTEwIDEwLTEwIDI2LjIyIDAgMzYuMmwxMzYgMTM2YzEwIDEwIDI2LjIgMTAgMzYuMiAwbDMyNC44LTMyNC44YzEwLTEwIDEwLTI2LjIgMC0zNi4yeiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/steps/check.svg
// module id = ./src/styles/steps/check.svg
// module chunks = 21